import { React } from 'react';
import styled from 'styled-components';
import MakingView from '../../Model/Share/Normal/MakingView';

function TimeLinePage() {

  return (
    <Container>
      <MakingView/>
    </Container>
  )
}

export default TimeLinePage;

const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;